import type { ComplianceTier, TierIndicatoren } from '../components/ComplianceTierMedaille';
import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

interface Professional {
  id: string;
  user_id: string;
  first_name: string;
  last_name: string;
  profile_photo_path?: string;
  professional_type: 'psycholoog_coach' | 'financieel_coach' | 'loopbaancoach' | 'teamcoach' | 'vitaliteitscoach' | 'burnout_coach' | 'vertrouwenspersoon' | 'bedrijfsmaatschappelijk_werker' | 'mediator';
  // KvK-gegevens, jaren zelfstandig en tarief zitten niet in het HR-profiel (FO):
  // die worden pas gedeeld zodra er onderhandeld wordt.
  availability_status: 'not_available' | 'immediately' | 'specific_date';
  available_from_date?: string;
  /** Werkgebied: reisradius in km vanaf het KvK-kantoor; null = heel Nederland */
  reisradius_km?: number | null;
  languages: string[];
  active_regions: string[];
  industry_experience: string[];
  work_experience: Array<{
    company: string;
    position: string;
    start_date: string;
    end_date?: string;
    current: boolean;
    description: string;
  }>;
  education: Array<{
    institution: string;
    degree: string;
    field: string;
    start_year: number;
    end_year?: number;
    current: boolean;
  }>;
  city: string;
  average_rating?: number;
  total_reviews: number;
  email: string;
  phone: string;
  /** Profielkop: bedrijfsgegevens van de praktijk (FO) */
  /** Compliance Vetting Tier (medaille + lint) */
  compliance_tier?: ComplianceTier;
  compliance_indicatoren?: TierIndicatoren | null;
  company_name?: string | null;
  company_logo_url?: string | null;
  /** Gesplitste bio (FO stap 3) */
  bio_medewerker?: string | null;
  bio_werkgever?: string | null;
  /** Expertise- en doelgroeptags (FO stap 4) */
  specialisatie_tags?: string[];
  doelgroep_niveaus?: string[];
  affinity?: string[];
  /** Introductievideo: upload of YouTube/Vimeo-link (FO stap 7) */
  intro_video_path?: string | null;
  intro_video_url?: string | null;
  show_employers_on_profile?: boolean;
  /** Opdrachtgevers die de professional op zijn profiel toont */
  employer_references?: Array<{
    company_name?: string | null;
    logo_url?: string | null;
    status?: string;
    connected_at?: string;
  }>;
}

interface ProfessionalDetailResponse {
  success: boolean;
  data: Professional;
}

export const useProfessionalDetail = (professionalId: string) => {
  return useQuery<Professional>({
    queryKey: ['professional-detail', professionalId],
    queryFn: async () => {
      const response = await api.get<ProfessionalDetailResponse>(`/employer/professional/${professionalId}`);
      return response.data.data;
    },
    enabled: !!professionalId,
    staleTime: 10 * 60 * 1000 // 10 minutes
  });
};
